import { NgModule } from '@angular/core';
import { AmountHumanizerPipePipe, AmountFormatPipe, AmountPipePipe, FilterPipePipe, NumberHighlighterPipePipe, OrderByPipe, SafePipe, GetLogoPathPipe, GetLogoPathBySchemePipe, GetBankLogoPipe, LeadingZeroPipe, AbsPipe, XirrPipe } from './gws-filter.pipe';

@NgModule({
  imports: [
  ],
  declarations: [AmountPipePipe,AmountFormatPipe,AmountHumanizerPipePipe,NumberHighlighterPipePipe,FilterPipePipe,OrderByPipe,SafePipe, GetLogoPathPipe, GetLogoPathBySchemePipe, GetBankLogoPipe, LeadingZeroPipe, AbsPipe, XirrPipe],
  exports:[AmountPipePipe,AmountFormatPipe,AmountHumanizerPipePipe,NumberHighlighterPipePipe,FilterPipePipe,OrderByPipe,SafePipe, GetLogoPathPipe, GetLogoPathBySchemePipe, GetBankLogoPipe, LeadingZeroPipe, AbsPipe, XirrPipe]

})
export class GwsFilterModule {}

